enum JobsDisplayType {
  LIST = 'List',
  CALENDAR = 'Calendar'
}

export default JobsDisplayType
